<template>
    <svg width="22"
         height="23"
         viewBox="0 0 22 23"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M4.565 2.44942C4.565 3.80248 3.5475 4.89884 2.29167 4.89884C1.03583 4.89884 0.0183333 3.80248 0.0183333 2.44942C0.0183333 1.09734 1.03583 0 2.29167 0C3.5475 0 4.565 1.09734 4.565 2.44942ZM4.58333 6.85838H0V22.5347H4.58333V6.85838ZM11.9002 6.85838H7.34617V22.5347H11.9011V14.3056C11.9011 9.73008 17.4277 9.35581 17.4277 14.3056V22.5347H22V12.6086C22 4.88806 13.8215 5.16926 11.9002 8.96978V6.85838Z" fill="black"/>
    </svg>
</template>
